import script from "./Portal.vue?vue&type=script&setup=true&lang=js"
export * from "./Portal.vue?vue&type=script&setup=true&lang=js"

export default script